/**
 * `defer-templates-marketplace` v0 — copy for the curated marketplace
 * tab + the landing-page `/marketplace` route.
 *
 * No dynamic strings; everything passes through this catalogue per
 * `AGENTS.md` hard rule 4 (no inline strings in JSX).
 */

import type { MarketplacePersona } from '@rynora/contracts';

export const MARKETPLACE = {
  // ---- Tab + heading ----
  tabLabel: 'Marketplace',
  panelHeading: 'Marketplace',
  panelSubheading: 'Curated flow templates from the Rynora team. Insert into any project to start running.',
  // ---- Card ----
  insertCta: 'Insert into project',
  inserting: 'Inserting…',
  insertSuccess: 'Template inserted — opening the flow.',
  insertError: "We couldn't insert that template. Please try again.",
  // ---- Empty / error states ----
  loading: 'Loading the marketplace…',
  emptyTitle: 'No templates yet',
  emptyBody: 'The Rynora team is curating the first batch. Check back soon.',
  loadError: "We couldn't load the marketplace right now.",
  loadErrorRetry: 'Try again',
  // ---- Project picker ----
  pickProjectTitle: 'Choose a project',
  pickProjectBody: 'The new flow will land in this project.',
  pickProjectConfirm: 'Insert here',
  pickProjectCancel: 'Cancel',
  noProjectsTitle: 'Create a project first',
  noProjectsBody: 'You need at least one project to insert a template into.',
  // ---- Landing page ----
  landingTitle: 'The Rynora playbook',
  landingSubtitle:
    'These are the flows we ship for ourselves — login, checkout, search-and-filter, signup with email verification, and contact-form. Sign up to drop them straight into your project.',
  landingSignUpCta: 'Sign up to use',
  landingMore: 'More templates ship every release.',
} as const;

export type MarketplaceCopyKey = keyof typeof MARKETPLACE;

/** Persona-badge labels rendered next to each card. */
export const MARKETPLACE_PERSONA_LABEL: Record<MarketplacePersona, string> = {
  login: 'Login',
  checkout: 'Checkout',
  'search-and-filter': 'Search & filter',
  'signup-with-email-verification': 'Signup',
  'contact-form': 'Contact form',
};

/** Lucide icon names per persona; consumed by the card component. */
export const MARKETPLACE_PERSONA_ICON: Record<MarketplacePersona, string> = {
  login: 'LogIn',
  checkout: 'ShoppingCart',
  'search-and-filter': 'Search',
  'signup-with-email-verification': 'UserPlus',
  'contact-form': 'Mail',
};
